import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectSiteLang } from "../../../store/userSlice";
import { FormatDate } from "../../../utils/generalUtils";
import style from "./index.module.css";
import singleNewsStyle from "../../../pages/SingleNews/index.module.css";
import { useTranslation } from "../../../hooks/useTranslation";

const LatestNews = ({ image, title, id, tags, created_at }: ComponentPropsType) => {
  const { locale } = useTranslation();

  return (
    <Link to={`/news/${id}`} className={style.news}>
      <img src={image} alt="" />
      <div className={style.news_details}>
        {created_at && (
          <p className={style.news_details__desc}>
            <FormatDate value={created_at} />
          </p>
        )}
        <p className={style.news_details__title}>{title}</p>
        {tags.length > 0 && (
          <ul className={singleNewsStyle.blog_tags} style={{ marginTop: 0 }}>
            <li>{locale("tags")}:</li>
            {tags.map((tag: string, index: number) => (
              <li key={index}>{tag}</li>
            ))}
          </ul>
        )}
        {/* <p className={style.news_details__desc}> */}
        {/* {topic.substr(0, 100)} */}
        {/* {topic.length > 100 && "..."} */}
        {/* </p> */}
      </div>
    </Link>
  );
};

export default LatestNews;

type ComponentPropsType = {
  id: number;
  image: string;
  title: string;
  topic: string;
  tags: string[];
  created_at: string;
};
